import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';


import "./assets/scss/light-bootstrap-dashboard-react.scss?v=2.0.0";

import "@fortawesome/fontawesome-free/css/all.min.css";

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { AuthProvider, useAuth } from './AuthProvider';
import AdminLayout from "layouts/Admin.js";

import Login from "components/LoginandOutpage/Login.js";

const root = ReactDOM.createRoot(document.getElementById("root"));

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { authLoading } = useAuth();
  const isAuthenticated = sessionStorage.getItem('userInfo');

  return (
    <Route
      {...rest}
      render={props => {
        if (authLoading) return null;
        return isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/pass/login", state: { from: props.location } }} />
        );
      }}
    />
  );
};

// MSAL v3 requires initialize() to complete before any API calls (including
// handleRedirectPromise in AuthProvider). Initialize first, then mount.
const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize().then(() => {
  root.render(
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <Switch>
            <Route exact path="/" component={Login} />
            <Route path="/pass/login" component={Login} />
            <ProtectedRoute path="/pass" component={AdminLayout} />
          </Switch>
        </AuthProvider>
      </MsalProvider>
    </BrowserRouter>
  );
});
